var map = {
	"./Cart": 7051,
	"./Cart.vue": 7051,
	"./Main": 9459,
	"./Main.vue": 9459,
	"./data/data": 2480,
	"./data/data.json": 2480,
	"./img/black_b2.jpg": 7654,
	"./img/black_c.png": 6096,
	"./img/black_p.png": 6134,
	"./img/black_p2.jpg": 2878,
	"./img/black_s.jpg": 1083,
	"./img/black_s2.png": 942,
	"./img/black_s3.jpg": 2716,
	"./img/black_t.jpg": 8216,
	"./img/blue_b.jpg": 7563,
	"./img/blue_j.jpg": 3013,
	"./img/blue_p.jpg": 3172,
	"./img/blue_s.jpg": 5513,
	"./img/blue_t.jpg": 5950,
	"./img/boots.png": 5639,
	"./img/brown_b.jpg": 5509,
	"./img/brown_c.jpg": 8394,
	"./img/brown_p.jpg": 8595,
	"./img/brown_p2.jpg": 6374,
	"./img/coat.png": 6468,
	"./img/green_j.jpg": 60,
	"./img/green_p.jpg": 9676,
	"./img/green_t.jpg": 3180,
	"./img/grey_c.jpg": 3613,
	"./img/grey_c2.jpg": 5536,
	"./img/grey_j.jpg": 269,
	"./img/jumper.png": 3606,
	"./img/logo.jpg": 539,
	"./img/orange_j.jpg": 1514,
	"./img/orange_t.png": 976,
	"./img/pants.png": 2177,
	"./img/pattern_b.png": 1991,
	"./img/pattern_b2.jpg": 5355,
	"./img/pattern_c.jpg": 782,
	"./img/pattern_s.jpg": 6294,
	"./img/pink_c.png": 4307,
	"./img/pink_j.jpg": 9485,
	"./img/pink_p.jpg": 1912,
	"./img/pink_p2.jpg": 7077,
	"./img/purple_c.jpg": 5461,
	"./img/purple_p.jpg": 7648,
	"./img/red_b.jpg": 5468,
	"./img/red_c.png": 7699,
	"./img/red_s.jpg": 3374,
	"./img/red_t.jpg": 102,
	"./img/sneakers.png": 7538,
	"./img/tshirt.png": 2189,
	"./img/white_b.jpg": 8451,
	"./img/white_b2.jpg": 4574,
	"./img/white_j.jpg": 1871,
	"./img/white_j2.jpg": 7190,
	"./img/white_p.jpg": 978,
	"./img/white_s.jpg": 5661,
	"./img/white_s2.png": 5091,
	"./img/white_t.jpg": 1654,
	"./img/white_t2.jpg": 8138,
	"./img/white_t3.jpg": 9079,
	"./img/white_t4.png": 1916,
	"./img/yellow_c.jpg": 9298,
	"./img/yellow_j.png": 9121,
	"./img/yellow_j2.jpg": 2637,
	"./img/yellow_t.jpg": 810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7559;